import React, { useRef } from 'react';
import useGame from '../../../../../../hooks/use-game';
import Sentence from './Sentence';
import { FindTheLetterInterface } from '../../../../../../providers/GameProvider/types';
import makeStyles from '@mui/styles/makeStyles';

const FindTheLetterSinglePage: React.FC = () => {
  const activityContainerRef = useRef<HTMLDivElement>(null);
  const classes = useStyles({ containerWidth: activityContainerRef?.current?.clientWidth });
  const [{ currentData, activityData }] = useGame<FindTheLetterInterface>();
  const activityLetter = activityData?.book.characters[0].character;
  const spread = !currentData?.[0]?.png?.spreadLayout;

  const firstPageImage = currentData?.[0]?.png?.src;
  const secondPageImage = currentData?.[1]?.png?.src;

  return (
    <div
      ref={activityContainerRef}
      className={`${classes.wrapper} ${spread ? classes.spread : classes.glued}`}
    >
      <img src={firstPageImage} key={firstPageImage} />
      <img src={secondPageImage} key={secondPageImage} />
      <Sentence
        description={currentData?.[0]?.contents?.description}
        pageNumber={currentData?.[0]?.page?.pageNumber}
        activityLetter={activityLetter}
      />
      <Sentence
        description={currentData?.[1]?.contents?.description}
        pageNumber={currentData?.[1]?.page?.pageNumber}
        activityLetter={activityLetter}
      />
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  wrapper: {
    flex: 1,
    display: 'grid',
    gridRowGap: '1rem',
    height: '100%',
    '& img': {
      boxShadow: theme.shadows[3],
      height: 'auto',
      maxWidth: ({ containerWidth }: any) => theme.typography.pxToRem(containerWidth / 2),
      width: 'auto',
      maxHeight: '100%',
      alignSelf: 'center',
      justifySelf: 'center',
    },
  },
  glued: {
    gridTemplateColumns: `repeat(2, minmax(35vh, min-content))`,
    gridTemplateRows: 'minmax(0,1fr) minmax(5rem, 12vh)',
    justifyContent: 'center',
  },
  spread: {
    gridTemplateColumns: 'repeat(2, 1fr)',
    gridTemplateRows: 'minmax(0,1fr) min-content',
    gridColumnGap: '2rem',
    justifyContent: 'space-around',
    width: '100%',
  },
}));

export default FindTheLetterSinglePage;
